import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { ApplicationState } from '@/state'
import { TableHeadCellPropsType } from '@/state/ui/global/models'
import { PlayerCardModels } from '@/state/player-card'

import useTableSort from '@/hooks/table/use-table-sort.hook'
import routes from '@/routes'

export const usePlayerSearchTable = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const { isLoadingSearch, players, paginationSearch } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )

  let headCells: TableHeadCellPropsType<PlayerCardModels.PlayerCardType>[] = [
    { id: 'id', label: t('labels.playerId'), width: 250, sort: false },
    {
      id: 'username',
      label: t('labels.username'),
      width: 150,
      sort: false,
    },
    {
      id: 'firstName',
      label: t('labels.name'),
      width: 150,
      sort: false,
    },
    {
      id: 'email',
      label: t('labels.email'),
      width: 150,
      sort: false,
    },
    {
      id: 'registrationDate',
      label: t('labels.registrationDate'),
      width: 100,
      sort: false,
    },
    { id: 'country', label: t('labels.country'), width: 100, sort: false },
    {
      id: 'city',
      label: t('labels.city'),
      width: 100,
      sort: false,
    },
  ]

  const sortedInitialState = 'registrationDate'

  const { sortedRows, createSortHandler, order, orderBy } = useTableSort<
    PlayerCardModels.PlayerCardType,
    keyof PlayerCardModels.PlayerCardType
  >(players, sortedInitialState, 'desc')

  const onPlayerClick = (playerId: string) => {
    navigate(`${routes.playerCard.PLAYER_CARD}/${playerId}`)
  }

  return {
    sortedRows,
    order,
    orderBy,
    headCells,
    isLoadingSearch,
    pagination: paginationSearch,
    onPlayerClick,
    createSortHandler,
  }
}
